import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import type { RefObject } from 'react';
interface Props {
  children: React.ReactNode;
  scrollRef: RefObject<HTMLDivElement | null>;
}
function ChatListLayout(t0) {
  const $ = _c(3);
  const {
    children,
    scrollRef
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== scrollRef) {
    t1 = <div className="scrollbar-custom flex flex-1 flex-col overflow-y-auto p-[12px]" ref={scrollRef}>{children}</div>;
    $[0] = children;
    $[1] = scrollRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export default ChatListLayout;